import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LabelsLayout = ({ children }) => {
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleMouseEnter = (menu) => setOpenMenu(menu);
  const handleMouseLeave = () => setOpenMenu(null);

  const isActive = location.pathname.includes("/certificats/promot");
  const isOrganismeActif = location.pathname.includes(
    "/certificats/organismes"
  );

  const isEvigilance = location.pathname.includes("/certificats/e-vigilance");

  return (
    <main>
      <section className="bg-blue-800 pt-14 pb-0 text-white">
        <div className="container mx-auto flex flex-col pt-4 px-6">
          <h1 className=" text-[1.1rem] md:text-xl font-semibold">
            CEISNA – Base de données des Certificats de santé numérique en
            Afrique
          </h1>
          <div className=" space-x-1 md:space-x-6 pt-2 flex items-center">
            <button
              onClick={() => navigate("/accueil/certificats")}
              className={` ${
                location.pathname === "/accueil/certificats" && "bg-[#00075e]"
              } px-2 md:px-4 py-2  hover:bg-white hover:text-[#00075e] text-[0.8rem] md:text-[1rem] hover:underline transition-all`}
            >
              Accueil
            </button>

            <div
              className="relative inline-block"
              onMouseEnter={() => handleMouseEnter("devices")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                onClick={() => navigate("/organisme/recherche")}
                className={`px-2 md:px-4 cursor-pointer py-2 ${
                  (location.pathname === "/organisme/recherche" ||
                    isOrganismeActif) &&
                  "bg-[#00075e]"
                }  ${
                  openMenu === "devices" && "bg-white text-[#00075e]"
                }  hover:underline text-[0.7rem] md:text-[1rem] transition-all`}
              >
                Certificats Organismes
              </button>
            </div>

            <div
              className="relative inline-block"
              onMouseEnter={() => handleMouseEnter("certs")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                onClick={() => navigate("/certificats/promot/recherche")}
                className={`px-2 md:px-4 cursor-pointer py-2 ${
                  (location.pathname === "/certificats/promot/recherche" ||
                    isActive) &&
                  "bg-[#00075e]"
                }  ${
                  openMenu === "certs" && "bg-white text-[#00075e]"
                }  hover:underline text-[0.7rem] md:text-[1rem]  transition-all`}
              >
                Certificats Promoteurs
              </button>
            </div>
            <div
              className="relative inline-block"
              onMouseEnter={() => handleMouseEnter("e-vigilance")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                onClick={() => navigate("/certificats/e-vigilance/recherche")}
                className={`px-2 md:px-4 cursor-pointer py-2 ${
                  (location.pathname === "/certificats/e-vigilance/recherche" ||
                    isEvigilance) &&
                  "bg-[#00075e]"
                }  ${
                  openMenu === "e-vigilance" && "bg-white text-[#00075e]"
                }  hover:underline text-[0.7rem] md:text-[1rem]  transition-all`}
              >
                e-Vigilance CEISNA
              </button>
            </div>
          </div>
        </div>
      </section>
      {children}
    </main>
  );
};

export default LabelsLayout;
